import { useState, useEffect } from 'react'

/**
 * Subscribe to a CSS media query and re-render when it changes.
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
  )

  useEffect(() => {
    const media = window.matchMedia(query)
    function onChange(event) {
      setMatches(event.matches)
    }
    media.addEventListener('change', onChange)
    setMatches(media.matches)
    return () => media.removeEventListener('change', onChange)
  }, [query])

  return matches
}

/** True when the off-canvas sidebar layout is active (< lg / 1024px). */
export function useIsMobileNav() {
  return useMediaQuery('(max-width: 1023px)')
}
